import { Icons } from '@commenda/kakashi';
import { PageEmptyState } from '../../../components/empty-state';

interface IndirectTaxTransactionsEmptyStateProps {
  onConnectIntegration?: () => void;
  onImportTransactions?: () => void;
}

const IndirectTaxTransactionsEmptyState = ({
  onConnectIntegration,
  onImportTransactions,
}: IndirectTaxTransactionsEmptyStateProps) => {
  return (
    <PageEmptyState
      title="Upload your transactions"
      description="Upload your past transactions to check for potential exposure."
      primaryAction={{
        label: 'Connect integration',
        icon: <Icons.Link01 className="size-4" />,
        onClick: onConnectIntegration,
      }}
      secondaryAction={{
        label: 'Import transactions',
        icon: <Icons.Download01 className="size-4" />,
        onClick: onImportTransactions,
      }}
    />
  );
};

export { IndirectTaxTransactionsEmptyState };
